import {
  USERS,
  SHOW_USER,
  CREATE_USER,
  DELETE_USER,
  UPDATE_USER,
  SEARCH_USERS,
} from './actionTypes';
import axios from '../../utils/axios';
import { hideSnackbar, showSnackbar } from '../snackbar';

const getUsers = page => (dispatch) => {
  dispatch({ type: `${USERS}_REQUEST` });
  axios.get(`employees?page=${page}`, { data: {} })
    .then(({ data: { employees, total_employees, total_pages } }) =>
      dispatch({
        type: `${USERS}_SUCCESS`,
        users: employees,
        total: total_employees,
        pages: total_pages,
      }))
    .catch(error => dispatch({ type: `${USERS}_ERROR`, error }));
};

const showUser = id => (dispatch) => {
  dispatch({ type: `${SHOW_USER}_REQUEST` });
  axios.get(`employees/${id}`, { data: {} })
    .then(response => dispatch({ type: `${SHOW_USER}_SUCCESS`, user: response.data.employee }))
    .catch(error => dispatch({ type: `${SHOW_USER}_ERROR`, error }));
};

const updateUser = user => (dispatch) => {
  dispatch({ type: `${UPDATE_USER}_REQUEST` });
  dispatch(hideSnackbar());
  axios.put(`employees/${user.employee.id}`, user)
    .then(() => {
      dispatch(showSnackbar('El usuario fue actualizado correctamente.', 'success'));
      dispatch({ type: `${UPDATE_USER}_SUCCESS`, user: user.employee });
    })
    .catch((error) => {
      dispatch(showSnackbar('Ha ocurrido un error al actualizar el usuario.', 'error'));
      dispatch({ type: `${UPDATE_USER}_ERROR`, error });
    });
};

const deleteUser = id => (dispatch) => {
  dispatch({ type: `${DELETE_USER}_REQUEST` });
  axios.delete(`employees/${id}`, { data: {} })
    .then(() => dispatch({ type: `${DELETE_USER}_SUCCESS`, id }))
    .catch(error => dispatch({ type: `${DELETE_USER}_ERROR`, error }));
};

const createUser = user => (dispatch) => {
  dispatch({ type: `${CREATE_USER}_REQUEST` });
  dispatch(hideSnackbar());
  axios.post('employees', user)
    .then((response) => {
      dispatch(showSnackbar('El usuario fue creado correctamente.', 'success'));
      dispatch({ type: `${CREATE_USER}_SUCCESS`, user: response.data });
    })
    .catch((error) => {
      dispatch(showSnackbar('Ha ocurrido un error al crear el usuario.', 'error'));
      dispatch({ type: `${CREATE_USER}_ERROR`, error });
    });
};

const search = query => (dispatch) => {
  dispatch({ type: `${SEARCH_USERS}_REQUEST` });
  axios.get('employees/search', {
    params: {
      ...query,
    },
    data: {},
  })
    .then(({ data: { employees, total_employees, total_pages } }) =>
      dispatch({
        type: `${SEARCH_USERS}_SUCCESS`,
        users: employees,
        total: total_employees,
        pages: total_pages,
      }))
    .catch(error => dispatch({ type: `${SEARCH_USERS}_ERROR`, error }));
};

export {
  getUsers,
  showUser,
  updateUser,
  deleteUser,
  createUser,
  search,
};



// WEBPACK FOOTER //
// ./src/actions/users/index.js